import { render, staticRenderFns } from "./BackDrop.vue?vue&type=template&id=2ccb685a&scoped=true&"
import script from "./BackDrop.vue?vue&type=script&lang=js&"
export * from "./BackDrop.vue?vue&type=script&lang=js&"
import style0 from "./BackDrop.vue?vue&type=style&index=0&id=2ccb685a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb685a",
  null
  
)

export default component.exports